import { videoControlPlayer } from './utils';

export default () => {
    $('.modal-images').on('hidden.bs.modal', function() {
        $(this).find('iframe').each((index, iframe) => {	
            videoControlPlayer($(iframe), 'pause');
        });
	});
	
	$(window).on('keydown', function(event) {
		if (event.keyCode === keys.right) {
			$('.modal-images.show').find('.js-paging-next').trigger('click');
		}
	
		if (event.keyCode === keys.left) {
			$('.modal-images.show').find('.js-paging-prev').trigger('click');
		}
	});
	
	$('.js-open-gallery').on('click', function() {	
		localStorage.galleryId = $(this).data('category');
	});
	
	if (localStorage.galleryId) {
		$(`#gallery-modal-${localStorage.galleryId}`).modal('show');
	
		localStorage.removeItem('galleryId');
	}
}